import PropTypes from 'prop-types';

const ListItem = (params) => [
    {
        name: 'サイドバーの背景色',
        value: params?.sidebar?.background_color,
        key: 'sidebar',
        keySub: 'background_color',
    },
    {
        name: '選択されたメニューの背景色',
        value: params?.sidebar?.selected_background_color,
        key: 'sidebar',
        keySub: 'selected_background_color',
    },
    {
        name: '選択されたメニューのテキスト色',
        value: params?.sidebar?.selected_text_color,
        key: 'sidebar',
        keySub: 'selected_text_color',
    },
    {
        name: 'ログアウトの背景色',
        value: params?.sidebar?.logout_background_color,
        key: 'sidebar',
        keySub: 'logout_background_color',
    },
    {
        name: 'ログアウトのテキスト色',
        value: params?.sidebar?.logout_text_color,
        key: 'sidebar',
        keySub: 'logout_text_color',
    },
    {
        name: 'テーブル（リストテーブル）のヘッダータイトルの背景色',
        value: params?.list_table?.title_background_color,
        key: 'list_table',
        keySub: 'title_background_color',
    },
    {
        name: 'テーブル（リストテーブル）のヘッダータイトルのテキスト色',
        value: params?.list_table?.title_text_color,
        key: 'list_table',
        keySub: 'title_text_color',
    },
    {
        name: 'テーブル（リストテーブル）上のレコードの背景色',
        value: null,
    },
    {
        name: '偶数の行',
        value: params?.list_table?.even_record_background_color,
        subItem: true,
        key: 'list_table',
        keySub: 'even_record_background_color',
    },
    {
        name: '奇数行',
        value: params?.list_table?.odd_record_background_color,
        subItem: true,
        key: 'list_table',
        keySub: 'odd_record_background_color',
    },
    {
        name: 'テーブル（ショッピングテーブル）のヘッダータイトルの背景色',
        value: params?.shop_table?.title_background_color,
        key: 'shop_table',
        keySub: 'title_background_color',
    },
    {
        name: 'テーブル（ショッピングテーブル）のサブタイトルの背景色',
        value: params?.shop_table?.sub_title_background_color,
        key: 'shop_table',
        keySub: 'sub_title_background_color',
    },
    {
        name: 'テーブル（ショッピングテーブル）上のレコードの背景色',
        value: params?.shop_table?.record_background_color,
        key: 'shop_table',
        keySub: 'record_background_color',
    },
    {
        name: '画面全体の背景諸',
        value: params?.screen_background_color,
        key: 'screen_background_color',
    },
    {
        name: 'ボタン色',
        value: null,
    },
    // start button color
    {
        name: '共通ボタン',
        value: params?.button_background_color?.common_button,
        subItem: true,
        key: 'button_background_color',
        keySub: 'common_button',
    },
    {
        name: 'ショッピング用ボタン',
        value: params?.button_background_color?.shopping_button,
        subItem: true,
        key: 'button_background_color',
        keySub: 'shopping_button',
    },
    {
        name: '入場者向けのボタン背景色',
        value: params?.button_background_color?.viewer,
        subItem: true,
        key: 'button_background_color',
        keySub: 'viewer',
    },
    {
        name: '出展者向けのボタン背景色',
        value: params?.button_background_color?.organizer,
        subItem: true,
        key: 'button_background_color',
        keySub: 'organizer',
    },
    {
        name: '出展募集要項ボタン背景色',
        value: params?.button_background_color?.instruction,
        subItem: true,
        key: 'button_background_color',
        keySub: 'instruction',
    },
    // end button color
    {
        name: '画面名の色',
        value: params?.screen_name_text_color,
        key: 'screen_name_text_color',
    },
    {
        name: 'コンテンツのテキスト色（サイドバーのテキスト、テーブルの先頭にあるテキスト、テーブル上のレコードのテキストを含む）',
        value: params?.contents_text_color,
        key: 'contents_text_color',
    },
    {
        name: 'ボタンのテキスト色',
        value: params?.button_text_color,
        key: 'button_text_color',
    },
    {
        name: 'イベントのテキスト色',
        value: params?.event_name_text_color,
        key: 'event_name_text_color',
    },
    {
        name: '良くある質問ページの色',
        value: null,
    },
    {
        name: '質問の行',
        value: params?.question_page?.question_line_background_color,
        subItem: true,
        key: 'question_page',
        keySub: 'question_line_background_color',
    },
    {
        name: '回答の行',
        value: params?.question_page?.answer_line_background_color,
        subItem: true,
        key: 'question_page',
        keySub: 'answer_line_background_color',
    },
    {
        name: 'サイドバーのアイコン色',
        value: null,
    },
    {
        name: '選択済み',
        value: params?.sidebar_icon?.selected,
        subItem: true,
        key: 'sidebar_icon',
        keySub: 'selected',
    },
    {
        name: 'その他',
        value: params?.sidebar_icon?.other,
        subItem: true,
        key: 'sidebar_icon',
        keySub: 'other',
    },
    {
        name: '「状況」項目の背景色',
        value: params?.background_color_status_live_seminar,
        key: 'background_color_status_live_seminar',
    },
    {
        name: '「料金」項目の背景色',
        value: params?.background_color_price_live_seminar,
        key: 'background_color_price_live_seminar',
    },
    {
        name: '「企業名」項目の背景色',
        value: params?.text_color_company_name,
        key: 'text_color_company_name',
    },
];

ListItem.defaultProps = {
    params: {},
};

ListItem.propTypes = {
    params: PropTypes.oneOfType([() => null, PropTypes.object]),
};

export default ListItem;
